import React from 'react';
import { useT } from '../i18n/LanguageContext';

const LegalNotice = () => {
  const { lang } = useT();

  const content = {
    fr: {
      badge: 'GPE – ÉNERGIES & SERVICES',
      title: 'Mentions légales',
      subtitle:
        'Informations légales relatives au site GPE – Énergies & Services.',

      sections: [
        {
          title: 'Éditeur',
          paragraphs: [
            'Le site www.gpefrance.eu est édité par SASU GPE.',
            'GPE\nSASU au capital de 10 000 €\nRCS Marseille B 947 903 829\nTVA intracommunautaire : FR38947903829',
            'Directeur de la publication : Khodir Ali',
            'Email : contact@gpefrance.eu\nTéléphone : +33 4 42 07 22 62',
          ],
        },

        {
          title: 'Hébergement',
          paragraphs: [
            'Le site est hébergé par IONOS France, 7 Pl. de la Gare, 57200 Sarreguemines, France.',
          ],
        },

        {
          title: 'Description des services',
          paragraphs: [
            'Le site a pour objectif de présenter les activités, services et réalisations de GPE – Énergies & Services. Les informations publiées sont fournies à titre indicatif et peuvent être modifiées ou mises à jour.',
          ],
        },

        {
          title: 'Propriété intellectuelle et contrefaçons',
          paragraphs: [
            'Les textes, images, graphismes, logos, icônes, logiciels et autres éléments du site sont protégés par les droits de propriété intellectuelle applicables.',
            'Toute reproduction, représentation, modification, adaptation ou exploitation non autorisée est interdite.',
          ],
        },

        {
          title: 'Liens hypertextes et cookies',
          paragraphs: [
            'Le site peut contenir des liens vers des sites tiers. GPE ne contrôle pas nécessairement leur contenu et ne peut être tenu responsable de leurs pratiques.',
            "Des cookies peuvent être utilisés afin de faciliter la navigation et de mesurer la fréquentation du site. L'utilisateur peut configurer son navigateur afin de contrôler ou refuser certains cookies.",
          ],
        },

        {
          title: 'Protection des données personnelles',
          paragraphs: [
            "Certaines données personnelles peuvent être collectées lorsque l'utilisateur utilise certains services ou remplit un formulaire.",
            "Conformément à la réglementation applicable, les utilisateurs disposent notamment de droits d'accès, de rectification, de suppression et d'opposition concernant leurs données personnelles.",
            'Pour toute demande relative aux données personnelles :',
          ],
          email: 'contact@gpefrance.eu',
        },
      ],
    },

    en: {
      badge: 'GPE – ENERGY & SERVICES',
      title: 'Legal Notice',
      subtitle:
        'Legal information relating to the GPE – Energy & Services website.',

      sections: [
        {
          title: 'Publisher',
          paragraphs: [
            'The website www.gpefrance.eu is published by SASU GPE.',
            'GPE\nSASU with share capital of €10,000\nRCS Marseille B 947 903 829\nIntracommunity VAT number: FR38947903829',
            'Publication Director: Khodir Ali',
            'Email: contact@gpefrance.eu\nTelephone: +33 4 42 07 22 62',
          ],
        },

        {
          title: 'Hosting',
          paragraphs: [
            'The website is hosted by IONOS France, 7 Pl. de la Gare, 57200 Sarreguemines, France.',
          ],
        },

        {
          title: 'Description of Services',
          paragraphs: [
            'The purpose of this website is to present the activities, services and projects of GPE – Energy & Services. The information published is provided for information purposes and may be modified or updated.',
          ],
        },

        {
          title: 'Intellectual Property and Counterfeiting',
          paragraphs: [
            'The texts, images, graphics, logos, icons, software and other elements of the website are protected by applicable intellectual property rights.',
            'Any unauthorised reproduction, representation, modification, adaptation or use is prohibited.',
          ],
        },

        {
          title: 'Hyperlinks and Cookies',
          paragraphs: [
            'The website may contain links to third-party websites. GPE does not necessarily control their content and cannot be held responsible for their practices.',
            'Cookies may be used to facilitate navigation and measure website traffic. Users may configure their browser to control or refuse certain cookies.',
          ],
        },

        {
          title: 'Protection of Personal Data',
          paragraphs: [
            'Certain personal data may be collected when users use certain services or submit a form.',
            'In accordance with applicable regulations, users have rights including access, rectification, deletion and objection regarding their personal data.',
            'For any request relating to personal data:',
          ],
          email: 'contact@gpefrance.eu',
        },
      ],
    },

    ar: {
      badge: 'GPE – الطاقة والخدمات',
      title: 'الإشعارات القانونية',
      subtitle:
        'المعلومات القانونية المتعلقة بموقع GPE – الطاقة والخدمات.',

      sections: [
        {
          title: 'الناشر',
          paragraphs: [
            'يتم نشر موقع www.gpefrance.eu من قبل شركة SASU GPE.',
            'GPE\nشركة SASU برأس مال قدره 10,000 يورو\nRCS Marseille B 947 903 829\nرقم ضريبة القيمة المضافة داخل الاتحاد الأوروبي: FR38947903829',
            'مدير النشر: Khodir Ali',
            'البريد الإلكتروني: contact@gpefrance.eu\nالهاتف: +33 4 42 07 22 62',
          ],
        },

        {
          title: 'الاستضافة',
          paragraphs: [
            'يتم استضافة الموقع من قبل IONOS France، 7 Pl. de la Gare, 57200 Sarreguemines, France.',
          ],
        },

        {
          title: 'وصف الخدمات',
          paragraphs: [
            'يهدف الموقع إلى تقديم أنشطة وخدمات ومشاريع GPE – الطاقة والخدمات. ويتم تقديم المعلومات المنشورة لأغراض إعلامية وقد يتم تعديلها أو تحديثها.',
          ],
        },

        {
          title: 'الملكية الفكرية والتقليد',
          paragraphs: [
            'تخضع النصوص والصور والرسومات والشعارات والأيقونات والبرامج والعناصر الأخرى الموجودة على الموقع لحقوق الملكية الفكرية المعمول بها.',
            'يُحظر أي نسخ أو تمثيل أو تعديل أو تكييف أو استخدام غير مصرح به.',
          ],
        },

        {
          title: 'الروابط وملفات تعريف الارتباط',
          paragraphs: [
            'قد يحتوي الموقع على روابط لمواقع تابعة لأطراف ثالثة. ولا تتحكم GPE بالضرورة في محتواها ولا تتحمل مسؤولية ممارساتها.',
            'قد يتم استخدام ملفات تعريف الارتباط لتسهيل التصفح وقياس زيارات الموقع. ويمكن للمستخدم إعداد متصفحه للتحكم في بعض ملفات تعريف الارتباط أو رفضها.',
          ],
        },

        {
          title: 'حماية البيانات الشخصية',
          paragraphs: [
            'قد يتم جمع بعض البيانات الشخصية عندما يستخدم المستخدم بعض الخدمات أو يملأ نموذجاً.',
            'وفقاً للأنظمة المعمول بها، يتمتع المستخدمون بحقوق تشمل الوصول إلى بياناتهم الشخصية وتصحيحها وحذفها والاعتراض على معالجتها.',
            'لأي طلب يتعلق بالبيانات الشخصية:',
          ],
          email: 'contact@gpefrance.eu',
        },
      ],
    },
  };

  const c = content[lang] || content.fr;
  const isArabic = lang === 'ar';

  return (
    <main className="bg-white min-h-screen">

      <section className="bg-[#0b1c3a] text-white pt-40 pb-20">
        <div className="max-w-6xl mx-auto px-6">

          <span className="text-[#f5c518] text-sm font-bold tracking-[0.2em]">
            {c.badge}
          </span>

          <h1 className="text-4xl md:text-5xl font-bold mt-4">
            {c.title}
          </h1>

          <p className="mt-4 text-white/70 max-w-3xl">
            {c.subtitle}
          </p>

        </div>
      </section>

      <section
        className="max-w-5xl mx-auto px-6 py-16 text-slate-700"
        dir={isArabic ? 'rtl' : 'ltr'}
      >

        {c.sections.map((section, index) => (
          <section
            key={index}
            className="mb-12"
          >

            <h2 className="text-2xl font-bold text-[#0b1c3a] mb-5">
              {section.title}
            </h2>

            {section.paragraphs.map((paragraph, pIndex) => (
              <p
                key={pIndex}
                className="text-base leading-8 mb-4 whitespace-pre-line"
              >
                {paragraph}
              </p>
            ))}

            {section.email && (
              <p className="font-semibold text-[#0b3b8c]">
                {section.email}
              </p>
            )}

          </section>
        ))}

      </section>

    </main>
  );
};

export default LegalNotice;